<!--
 * @Description: 
 * @Author: CcSimple
 * @Copyright: ©2022 sv-print 请自觉遵守LGPL开源协议
 * @Github: https://github.com/CcSimple
 * @Date: 2022-10-29 09:05:04
 * @LastEditors: CcSimple
 * @LastEditTime: 2023-06-20 15:24:20
-->
<template>
  <div style="height: 100%"></div>
</template>

<script>
// import * as SVPrint from "@sv-print/vue";
import Vue from "vue";
export default {
  name: "Desinger",
  props: {
    autoConnect: {
      type: Boolean,
      default: true,
    },
    config: Object,
    providers: Array,
    providerMap: Object,
    clearProviderContainer: Boolean,
    showPanels: Boolean,
    plugins: Array,
    template: Object,
    designOptions: Object,
    printData: {
      type: Object || Array,
      default: () => {},
    },
    templateKey: {
      type: String,
      default: "default-template",
    },
    title: {
      type: String,
      default: "默认模板",
    },
    authKey: {
      type: String,
      default:
        "53616C7465645F5F7BCCFBCC5D7FCC45BBD985DBB2D854604DACE0976DD5A5C0C2BC48847291A1E7D23B658CBBA58EBD40461AE2D6CEA435B92DDB5F4857AD08",
    },
    headerLogoHtml: {
      type: String,
      default: "<div>logo</div>",
    },
    headerTitle: {
      type: String,
      default: "啊啊啊啊",
    },
    events: Object,
    tags: Array,
    styleOption: {
      type: Object,
      default: () => {
        return {
          zoomTools: {
            // 缩放工具
            mode: "left",
            show: true,
            style: "left:100px;top:100px;",
          },
        };
      },
    },
    showOption: {
      type: Object,
      default: () => {
        return {
          showPower: false,
        };
      },
    },
    paperList: Array,
    theme: String,
    themeList: Array,
    miniMapOriginMode: {
      type: Boolean,
      default: false,
    },
    previewOptions: Object,
    onPreviewClick: Function,
    onImageChooseClick: Function,
    onPanelAddClick: Function,
    onFunctionClick: Function,
  },
  mounted() {
    // const designer = new SVPrint.Designer({
    //   target: this.$el,
    //   props: {
    //     ...this.$props,
    //     ...{ $$scope: {}, $$slots: this.createSlots() },
    //   },
    // });
    // designer.$on("onDesigned", (e) => {
    //   this.$emit("onDesigned", e);
    // });
    // this.designer = designer;
  },
  beforeDestroy() {
    this.designer.$destroy();
    this.designer = null;
  },
  watch: {
    $props: {
      handler(newValue, oldValue) {
        let copy = { ...newValue };
        for (let k in copy) {
          if (copy[k] === undefined) {
            delete copy[k];
          }
        }
        copy.$$slots = this.createSlots();
        this.designer.$set(copy);
      },
      deep: true,
    },
  },
  methods: {
    createSlots() {
      let slots = {};
      for (const key in this.$slots) {
        let vNode = this.$slots[key];
        let isMulti = vNode.length > 1;
        let Slot = Vue.extend({
          render: (h) => {
            if (isMulti) {
              return h("div", vNode);
            } else {
              let { tag, data, children } = vNode[0];
              return h(tag, data, children);
            }
          },
        });
        // 挂载后才能获取到 $el dom
        let slot = new Slot().$mount();
        slots[key] = slot.$el;
      }
      // 创建 svelte slot
      // return SVPrint.createSlots(slots);
    },
  },
};
</script>
